import { ToggleState } from "../types/types";

const initialState: ToggleState = {
  NAVBAR_TOGGLE: true,
};

export const toggleReducer = (
  state = initialState,
  action: { type: string; payload: string }
) => {
  switch (action.type) {
    case "SHOW":
      return { ...state, [action.payload]: true };
    case "HIDE":
      return { ...state, [action.payload]: false };
    case "TOGGLE":
      return { ...state, [action.payload]: !state[action.payload] };
    default:
      return state;
  }
};

export function getToggleState(state): ToggleState {
  return state.toggleState;
}
